import {ErrorMessage} from "src/typing";
import {isErrorException} from "@firefly/fly-http";


export default function format(reason: any): ErrorMessage {
    if (typeof reason === 'string') {
        return {
            title: reason
        }
    }
    if (isErrorException(reason)) {
        const {
            message,
            error: errorInfo,
            context,
        } = reason;
        const {
            request,
          response,
        } = context??{};
        const title = message;
        const subTitle = errorInfo ? `错误代码: ${errorInfo.code}` : undefined;
        return {
            title: title,
            subtitle: subTitle,
            details: [
                {
                    key: "X-TraceID",
                    value: response?.headers.get("X-TraceID"),
                },
                {
                    key: "Method",
                    value: request?.method,
                },
                {
                    key: "URL",
                    value: request?.url,
                }
            ]
        };
    }
    if (reason instanceof Error) {
        return {
            title: reason.message,
        }
    }

    if (reason?.message) {
        return {
            title: reason.message,
        }
    }
    return {
        title: "出错了！"
    }
}